import PropTypes from "prop-types";
import Card from "../shared/card";
import ImageIcon from "../shared/image_icon";
import RedDot from "../shared/red_dot";

const GroupTile = (props) => {
  return (
    <div className="col-3 text-center p-0">
      <a onClick={props.onClick}>
        <Card className="card-crossroads" bodyClassName="d-block p-0">
          <div className="col-12 d-flex align-items-center justify-content-center">
            <ImageIcon name={props.icon} width={32} height={32} />
          </div>
          <h3 className="d-block col-12 text-center label-3 mb-0 mt-1">{props.text}</h3>
          {props.showRedDot > 0 && <RedDot />}
        </Card>
      </a>
    </div>
  );
};

export default GroupTile;

GroupTile.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired,
  showRedDot: PropTypes.bool,
};

GroupTile.defaultProps = {
  showRedDot: false,
};
